import * as loggerx from 'utilities/loggerx';
import { getGraphQLClientInsights } from 'utilities/graphql';
import PlaySegments from 'utilities/video-session/playSegments.graphql';
import { Segment } from '@loomhq/createhq/dist/video-player/api/insights';

interface SyncRequest {
  videoId: string;
  sessionId?: string;
  segment: Segment;
  speed: number;
}

function createSegmentSyncer(): (options: SyncRequest) => Promise<void> {
  const map = new Map<string, string>();

  return async (options: SyncRequest) => {
    const segmentId = options.segment.id || '';
    const serverId = map.get(segmentId);

    try {
      const data = await syncSegments({
        ...options,
        serverId,
      });

      if (data && data.id) {
        map.set(segmentId, data.id);
      }
    } catch (e) {
      loggerx.error(e, {
        currentSegment: options.segment,
        videoId: options.videoId,
        sessionId: options.sessionId,
      });
    }
  };
}

type SegmentOptions = SyncRequest & {
  serverId?: string;
};

interface SyncResponse {
  id: string;
}

async function syncSegments(options: SegmentOptions): Promise<SyncResponse> {
  loggerx.addCrumb({
    message: 'sending segment',
    context: options.segment,
  });

  const { data } = await sendMutation(PlaySegments, options);
  const payload = data?.updateVideoPlaySegment;

  if (!payload) {
    throw Error('payload is undefined');
  }

  if (payload.message) {
    throw Error(payload.message);
  }

  return payload;
}

function sendMutation(mutation: unknown, options: SegmentOptions) {
  const { videoId, sessionId, serverId, segment, speed } = options;
  const client = getGraphQLClientInsights();

  return client.mutate({
    mutation,
    variables: {
      segment: {
        videoId,
        sessionId,
        sid: serverId,
        speed,
        start: segment.start,
        end: segment.end,
      },
    },
  });
}

export default createSegmentSyncer;
